import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { MatTooltipModule, MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from '@angular/material/tooltip';
import { FocusDirective } from '../directives/focus.directive';
import { NumericInputDirective } from '../directives/numeric-input-directive.directive';
import { ActivityItemComponent } from './activity-item/activity-item.component';
import { ActivityLogFlagComponent } from './activityLog-flag/activityLog-flag.component';
import { ActivityLogComponent } from './activityLog/activityLog.component';
import { SyncStatusComponent } from './syncStatus/syncStatus.component';
import { ActivityLogStatusComponent } from './activityLogStatus/activityLogStatus.component';
import { ActivityLogUnifiedCardComponent } from './activityLogUnified-card/activityLogUnified-card.component';
import { ActivityLogUnifiedComponent } from './activityLogUnified/activityLogUnified.component';
import { ChangeProjectComponent } from './changeProject/changeProject.component';
import { MessageItemComponent } from './message-item/message-item.component';
import { CreateNotableActivityComponent } from './modals/notable-activity/create-notable-activity/create-notable-activity.component';
import { EditNotableActivityComponent } from './modals/notable-activity/edit-notable-activity/edit-notable-activity.component';
import { NotableActivityComponent } from './modals/notable-activity/notable-activity.component';
import { ModalFooterComponent } from './modals/shared/modal-footer/modal-footer.component';
import { ModalHeaderComponent } from './modals/shared/modal-header/modal-header.component';
import { ClockOutComponent } from './modals/time/clock-out/clock-out.component';
import { CreateClosedBreakTimeComponent } from './modals/time/create-closed-time/create-closed-break-time/create-closed-break-time.component';
import { CreateClosedTimeComponent } from './modals/time/create-closed-time/create-closed-time.component';
import { CreateClosedWorkingTimeComponent } from './modals/time/create-closed-time/create-closed-working-time/create-closed-working-time.component';
import { StartBreakComponent } from './modals/time/create-open-time/start-break/start-break.component';
import { EndMealBreakComponent } from './modals/time/create-open-time/end-meal-break/end-meal-break.component';
import { ClockInComponent } from './modals/time/create-open-time/clock-in/clock-in.component';
import { CreateOpenTimeComponent } from './modals/time/create-open-time/create-open-time.component';
import { EditClosedTimeComponent } from './modals/time/edit-closed-time/edit-closed-time.component';
import { EditOpenTimeComponent } from './modals/time/edit-open-time/edit-open-time.component';
import { EditTimeComponent } from './modals/time/edit-time/edit-time.component';
import { TimeComponent } from './modals/time/time.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { ProjectListCardComponent } from './project-list-card/project-list-card.component';
import { ProjectListComponent } from './project-list/project-list.component';
import { ProjectTaskSelectionComponent } from './projectTaskSelection/projectTaskSelection.component';
import { ReturnActivityComponent } from './return-activity/return-activity.component';
import { SignaturePadComponent } from './signature-pad/signature-pad.component';
import { TeamDetailCardComponent } from './team-detail-card/team-detail-card.component';
import { TeamDetailOptionsComponent } from './team-detail-options/team-detail-options.component';
import { TeamFlagIndicatorComponent } from './team-flag-indicator/team-flag-indicator.component';
import { TeamListCardComponent } from './team-list-card/team-list-card.component';
import { TeamListComponent } from './team-list/team-list.component';
import { TimeClockComponent } from './timeClock/timeClock.component';
import { TimeRecordDurationComponent } from './timeRecord-duration/timeRecord-duration.component';
import { TimeRecordItemComponent } from './timeRecordItem/timeRecordItem.component';
import { TimeRecordListComponent } from './timeRecordList/timeRecordList.component';
import { TimeRecordsForDayComponent } from './timeRecordsForDay/timeRecordsForDay.component';
import { ChangeAssignmentComponent } from './modals/time/create-open-time/change-assignment/change-assignment.component';
import { SharedModule } from '../shared/shared/shared.module';
import { ClockOdometerValueComponent } from './clock-odometer-value/clock-odometer-value.component';
import { ActivityLogTotalMileageComponent } from './activity-log-total-mileage/activity-log-total-mileage.component';
import { MileageLogComponent } from './mileage-log/mileage-log.component';
import { MileageLogCardComponent } from './mileage-log-card/mileage-log-card.component';
import { OdometerReadingModalComponent } from './odometer-reading-modal/odometer-reading-modal.component';
import { AlertBannerComponent } from './alert-banner/alert-banner.component';
import { SwiperModule } from 'swiper/angular';
import { AdditionalDetailsComponent } from './additional-details/additional-details.component';
import { AdditionalDetailInputComponent } from './additional-details/additional-detail-input/additional-detail-input.component';
import { TooltipComponent } from '../shared/common/tooltip/tooltip.component';
import { SkeletonTableComponent } from '../shared/common/skeleton-table/skeleton-table.component';
import { SafeHtmlPipe } from '../utils/pipes/safe-html.pipe';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { CurrentAssignmentSelectorComponent } from './current-assignment-selector/current-assignment-selector.component';
import { TimecardsSearchComponent } from './timecards-search/timecards-search.component';
import { TimecardTemplatesSearchComponent } from './templates/timecard-templates-search.component';
import { TimecardsVisitDesktopComponent } from './timecards-visit-desktop/timecards-visit-desktop.component';
import { TimecardsInactiveUserComponent } from './timecards-inactive-user/timecards-inactive-user.component';
import { TimecardTemplateComponent } from './timecard-template/timecard-template.component';
import { TimecardComponent } from './timecard/timecard.component';
import { AutosaveStatusComponent } from './autosave-status/autosave-status.component';
import { MinutesToDecimalModalComponent } from './modals/minutes-to-decimal-modal/minutes-to-decimal-modal.component';
import { DriverSessionQrComponent } from './driver-session-qr/driver-session-qr.component';
import { DriverSessionQrControlComponent } from './driver-session-qr-control/driver-session-qr-control.component';


@NgModule({
  imports: [IonicModule, CommonModule, ReactiveFormsModule, FormsModule, SharedModule, NgxQRCodeModule, SwiperModule, MatTooltipModule],
  declarations: [
    TimeRecordListComponent,
    TimeRecordItemComponent,
    TimeClockComponent,
    SignaturePadComponent,
    ActivityLogComponent,
    SyncStatusComponent,
    ChangeProjectComponent,
    ProjectTaskSelectionComponent,
    MessageItemComponent,
    TeamDetailCardComponent,
    TimeRecordsForDayComponent,
    ReturnActivityComponent,
    TeamDetailOptionsComponent,
    ActivityLogUnifiedComponent,
    ActivityLogStatusComponent,
    SafeHtmlPipe,
    TooltipComponent,
    NumericInputDirective,
    FocusDirective,
    ActivityItemComponent,
    ProjectListComponent,
    ProjectListCardComponent,
    TeamListComponent,
    TeamListCardComponent,
    ProgressBarComponent,
    TimeRecordDurationComponent,
    ActivityLogUnifiedCardComponent,
    TeamFlagIndicatorComponent,
    ActivityLogFlagComponent,
    ModalHeaderComponent,
    ModalFooterComponent,
    NotableActivityComponent,
    CreateNotableActivityComponent,
    EditNotableActivityComponent,
    CreateOpenTimeComponent,
    ClockInComponent,
    ClockOutComponent,
    StartBreakComponent,
    EndMealBreakComponent,
    TimeComponent,
    CreateClosedWorkingTimeComponent,
    CreateClosedBreakTimeComponent,
    CreateClosedTimeComponent,
    EditTimeComponent,
    EditOpenTimeComponent,
    EditClosedTimeComponent,
    ChangeAssignmentComponent,
    ClockOdometerValueComponent,
    ActivityLogTotalMileageComponent,
    MileageLogComponent,
    MileageLogCardComponent,
    OdometerReadingModalComponent,
    AlertBannerComponent,
    AdditionalDetailsComponent,
    AdditionalDetailInputComponent,
    EmptyStateComponent,
    CurrentAssignmentSelectorComponent,
    TimecardTemplatesSearchComponent,
    TimecardsSearchComponent,
    TimecardsVisitDesktopComponent,
    TimecardsInactiveUserComponent,
    TimecardTemplateComponent,
    TimecardComponent,
    AutosaveStatusComponent,
    SkeletonTableComponent,
    MinutesToDecimalModalComponent,
    DriverSessionQrComponent,
    DriverSessionQrControlComponent
  ],
  exports: [
    TimeRecordListComponent,
    TimeRecordItemComponent,
    TimeClockComponent,
    SignaturePadComponent,
    ActivityLogComponent,
    SyncStatusComponent,
    ChangeProjectComponent,
    ProjectTaskSelectionComponent,
    MessageItemComponent,
    TeamDetailCardComponent,
    TimeRecordsForDayComponent,
    ReturnActivityComponent,
    TeamDetailOptionsComponent,
    ActivityLogUnifiedComponent,
    ActivityLogStatusComponent,
    SafeHtmlPipe,
    TooltipComponent,
    NumericInputDirective,
    FocusDirective,
    ActivityItemComponent,
    ProjectListComponent,
    ProjectListCardComponent,
    TeamListComponent,
    TeamListCardComponent,
    ProgressBarComponent,
    TimeRecordDurationComponent,
    ActivityLogUnifiedCardComponent,
    TeamFlagIndicatorComponent,
    ActivityLogFlagComponent,
    ModalHeaderComponent,
    ModalFooterComponent,
    NotableActivityComponent,
    CreateNotableActivityComponent,
    EditNotableActivityComponent,
    CreateOpenTimeComponent,
    ClockInComponent,
    ClockOutComponent,
    StartBreakComponent,
    EndMealBreakComponent,
    TimeComponent,
    CreateClosedWorkingTimeComponent,
    CreateClosedBreakTimeComponent,
    CreateClosedTimeComponent,
    EditTimeComponent,
    EditOpenTimeComponent,
    EditClosedTimeComponent,
    ChangeAssignmentComponent,
    ClockOdometerValueComponent,
    ActivityLogTotalMileageComponent,
    MileageLogComponent,
    MileageLogCardComponent,
    OdometerReadingModalComponent,
    AlertBannerComponent,
    AdditionalDetailsComponent,
    AdditionalDetailInputComponent,
    EmptyStateComponent,
    CurrentAssignmentSelectorComponent,
    TimecardTemplatesSearchComponent,
    TimecardsSearchComponent,
    TimecardsVisitDesktopComponent,
    TimecardsInactiveUserComponent,
    TimecardTemplateComponent,
    TimecardComponent,
    AutosaveStatusComponent,
    SkeletonTableComponent,
    DriverSessionQrComponent,
    DriverSessionQrControlComponent
  ],
  providers: [
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: { position: 'below', showDelay: 200, hideDelay: 0, touchendHideDelay: 0, disableTooltipInteractivity: true } as MatTooltipDefaultOptions,
    },
  ],
})
export class ComponentsModule {}
